/**
 * API Configuration
 * All API URLs and endpoints should be configured through environment variables.
 * No hardcoded URLs or ports allowed.
 */

// Get API URL from environment variable - no fallback
const API_URL = process.env.REACT_APP_API_URL;

// Validate that required environment variables are set
if (!API_URL) {
  throw new Error(
    'REACT_APP_API_URL is not defined in environment variables. ' +
    'Please check your .env file and ensure REACT_APP_API_URL is set.'
  );
}

// Export the validated API URL
export { API_URL };

// Optional: Export a helper function for constructing full API endpoints
export const getApiEndpoint = (path) => {
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_URL}${normalizedPath}`;
};

export default API_URL;
